import {
  Avatar,
  CardActionArea,
  CardActions,
  createStyles,
  Divider,
  Fab,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Theme,
  WithStyles,
  withStyles,
  Tooltip,
} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import PlaceIcon from "@material-ui/icons/Place";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import imagePlacholder from "../assets/images/image-placeholder.png";
import PageViewIcon from "@material-ui/icons/ViewCompact";
import * as React from "react";
import { SNACKBAR_TYPE } from "./SnackBarComponent";
import { CompaniesService } from "../services/CompaniesService";
import { EventEmitter } from "../events/EventEmitter";
import AddCompanyDialog, { MODE_TYPE } from "../dialogs/AddCompanyDialog";
import GenericDialog, { types } from "../dialogs/GenericDialog";
import PeopleIcon from "@material-ui/icons/People";
import AuditIcon from "@material-ui/icons/Assignment";
import { grey } from "@material-ui/core/colors";
import HasPermission from "../auth/HasPermission";
import { AuthConsumer } from "../routes/AuthContext";
import { isEmpty } from "../constants/constants";
import ManageCompanyUsersDialog from "../dialogs/ManageCompanyUsersDialog";
import { AssetsService } from "../services/AssetsService";
import SelectDashboardDialog from "../dialogs/SelectDashboardDialog";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    img: {
      "max-width": 120,
      "max-height": 120,
      overflow: "hidden",
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    card: {
      width: 400,
    },
    margin: {
      margin: theme.spacing(1),
    },
    media: {
      height: 140,
    },
  });
interface Props extends WithStyles<typeof styles> {
  companyData: any;
  onClick: any;
  onUpdatePage: any;
}
class CompanyCardComponent extends React.Component<Props> {
  state = {
    anchorEl: null,
    openAddCompanyDialog: false,
    openManageUsersDialog: false,
    openConfirmationDialog: false,
    isSuccess: false,
    isError: false,
    openSelectDashboard: false,
    companyData: Object(),
    selectedImageItem: { base64: "", item: { filename: "", _id: "" } },
  };
  componentDidMount = () => {
    this.setState(
      {
        companyData: this.props.companyData,
      },
      () => {
        this.downloadQuestionAsset(this.state.companyData.imageItem);
      }
    );
  };
  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (this.props.companyData.imageItem && prevProps.companyData.imageItem) {
      if (
        this.props.companyData.imageItem.filename !==
        prevProps.companyData.imageItem.filename
      ) {
        this.setState(
          {
            companyData: this.props.companyData,
          },
          () => {
            this.downloadQuestionAsset(this.state.companyData.imageItem);
          }
        );
      }
    }
  };
  downloadQuestionAsset = (imageItem: any) => {
    if (!imageItem) {
      return;
    }
    let assetsService: AssetsService = new AssetsService();
    this.setState({
      isLoading: true,
    });
    assetsService.getAsset(imageItem.filename).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.data) {
        imageItem.base64 = resp.data;
        this.setState({ selectedImageItem: imageItem });
      }
    });
  };
  handleClick = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({
      openAddCompanyDialog: false,
      openManageUsersDialog: false,
      openConfirmationDialog: false,
      openSelectDashboard: false,
    });
  };
  handleEditCompany = () => {
    this.setState({ openAddCompanyDialog: true }, () => {
      if (this.props.onUpdatePage) {
        this.props.onUpdatePage();
      }
      this.getCompany(this.state.companyData._id);
    });
  };
  handleDeleteCompany = () => {
    this.setState({ openConfirmationDialog: true });
  };
  handleManageUsersCompany = () => {
    this.setState({ openManageUsersDialog: true });
  };

  getCompany = (companyId: String) => {
    let companiesService: CompaniesService = new CompaniesService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    companiesService.getCompany(companyId).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.company) {
        this.setState(
          {
            companyData: resp.company,
          },
          () => {
            this.downloadQuestionAsset(this.state.companyData.imageItem);
          }
        );
      } else {
        this.setState({
          showCompanies: false,
          showToolBarButton: false,
        });
        if (resp && resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        }
      }
    });
  };
  handleDashboard = () => {
    this.setState({
      openSelectDashboard: true,
    });
    // history.push({
    //   pathname: `/segpi/dashboard`,
    //   state: { companyData: this.state.companyData },
    // });
  };

  handleConfirmedDelete = () => {
    const { onUpdatePage } = this.props;
    let companiesService: CompaniesService = new CompaniesService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    companiesService.deleteCompany(this.state.companyData._id).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      this.setState({ isLoading: false });
      if (resp && resp.success) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Deleted Successfully",
        });
        if (onUpdatePage) {
          onUpdatePage();
        }
        this.setState({ isLoading: false, openConfirmationDialog: false });
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  handleOnSubmit = (values: any) => {
    const { companyData, onUpdatePage } = this.props;
    let companiesService: CompaniesService = new CompaniesService();
    this.setState({ isLoading: true });
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    companiesService.updateCompany(companyData._id, values).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success) {
        this.setState({ isLoading: false, openAddCompanyDialog: false });
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Edited Successfully",
        });
        if (onUpdatePage) {
          onUpdatePage();
        }
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        this.setState({ isLoading: false });
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: "Oops something happened",
        });
      }
    });
  };
  renderAddCompanyDialog = () => {
    const { companyData } = this.props;
    return (
      <AddCompanyDialog
        title={"Add Company"}
        mode={MODE_TYPE.EDIT}
        companyData={companyData}
        open={this.state.openAddCompanyDialog}
        handleClose={this.handleClose}
        handleOnSubmit={this.handleOnSubmit}
      />
    );
  };
  renderManageUsersDialog = () => {
    const { companyData } = this.props;
    return (
      <ManageCompanyUsersDialog
        title={`Manage Users for: ${companyData.name}`}
        mode={"ADD"}
        companyData={companyData}
        open={this.state.openManageUsersDialog}
        handleClose={this.handleClose}
        handleOnSubmit={this.handleOnSubmit}
      />
    );
  };
  renderConfirmationDialog = () => {
    const { companyData } = this.props;
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Deleting ${companyData.name}`}
        message={"Are you sure want to delete this company"}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.openConfirmationDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  renderSelectDashbaordDialog = () => {
    return (
      <SelectDashboardDialog
        dialogTitle={`Select dashboard`}
        open={this.state.openSelectDashboard}
        company={this.state.companyData}
        onClose={() => this.handleClose()}
      />
    );
  };

  render() {
    const { classes, companyData, onClick } = this.props;
    return (
      <React.Fragment>
        {this.renderAddCompanyDialog()}
        {this.renderConfirmationDialog()}
        {this.renderManageUsersDialog()}
        {this.renderSelectDashbaordDialog()}
        <AuthConsumer>
          {({ authenticated, user, accessRules }) => (
            <Card className={classes.card}>
              <CardActionArea onClick={(event) => onClick(event, companyData)}>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  {this.state.selectedImageItem.base64 &&
                    !isEmpty(this.state.selectedImageItem.base64) ? (
                    <img
                      alt={"companyCard"}
                      style={{
                        flex: 0.4,
                        width: 120,
                        height: 120,
                        padding: 20,
                      }}
                      className={classes.media}
                      src={`data:image/png;base64,${this.state.selectedImageItem.base64}`}
                      title="Contemplative Reptile"
                    />
                  ) : (
                    <img
                      className={classes.img}
                      alt="complex"
                      src={imagePlacholder}
                    />
                  )}

                  <Typography
                    style={{ flex: 0.6, marginLeft: 20 }}
                    gutterBottom
                    variant="h5"
                    component="h2"
                  >
                    {companyData.name}
                  </Typography>
                </div>
              </CardActionArea>
              <Divider />
              <CardContent>
                <List className={classes.root}>
                  <ListItem button onClick={() => { }}>
                    <ListItemAvatar>
                      <Avatar>
                        <EmailIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Email"
                      secondary={companyData.email}
                    />
                  </ListItem>
                  {companyData && (
                    <ListItem button onClick={() => { }}>
                      <ListItemAvatar>
                        <Avatar>
                          <PlaceIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary="Address"
                        secondary={`${companyData.line1 ? companyData.line1 : ""
                          } ${companyData.line2 ? companyData.line2 : ""} ${companyData.city ? companyData.city : ""
                          } ${companyData.province && companyData.province.label
                            ? companyData.province.label
                            : ""
                          } ${companyData.postalCode ? companyData.postalCode : ""
                          }`}
                      />
                    </ListItem>
                  )}
                  <ListItem button onClick={() => { }}>
                    <ListItemAvatar>
                      <Avatar>
                        <PhoneIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Phone"
                      secondary={companyData.phone}
                    />
                  </ListItem>
                </List>
              </CardContent>
              <Divider />
              <CardActions
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <HasPermission
                  role={user.role}
                  accessRules={accessRules}
                  perform="company-users:view"
                  data={user.role}
                  yes={() => (
                    <Tooltip title="Manage users">
                      <Fab
                        size="small"
                        aria-label="add"
                        style={{ backgroundColor: grey[400] }}
                        className={classes.margin}
                        onClick={() => this.handleManageUsersCompany()}
                      >
                        <PeopleIcon style={{ color: "white" }} />
                      </Fab>
                    </Tooltip>
                  )}
                  no={() => <div></div>}
                />
                <HasPermission
                  role={user.role}
                  accessRules={accessRules}
                  perform="dashboard:view"
                  data={user.role}
                  yes={() => (
                    <Tooltip title="Dashboard">
                      <Fab
                        size="small"
                        aria-label="add"
                        style={{ backgroundColor: grey[400] }}
                        className={classes.margin}
                        onClick={() => this.handleDashboard()}
                      >
                        <AuditIcon style={{ color: "white" }} />
                      </Fab>
                    </Tooltip>
                  )}
                  no={() => <div></div>}
                />
                <HasPermission
                  role={user.role}
                  accessRules={accessRules}
                  perform="companies:edit"
                  yes={() => (
                    <Tooltip title="Edit company">
                      <Fab
                        size="small"
                        aria-label="add"
                        style={{ backgroundColor: grey[400] }}
                        className={classes.margin}
                        onClick={() => this.handleEditCompany()}
                      >
                        <EditIcon style={{ color: "white" }} />
                      </Fab>
                    </Tooltip>
                  )}
                  no={() => <div></div>}
                />
                <HasPermission
                  role={user.role}
                  accessRules={accessRules}
                  perform="company:view"
                  yes={() => (
                    <Tooltip title="View company">
                      <Fab
                        size="small"
                        aria-label="add"
                        style={{ backgroundColor: grey[400] }}
                        className={classes.margin}
                        onClick={(event) => onClick(event, companyData)}
                      >
                        <PageViewIcon style={{ color: "white" }} />
                      </Fab>
                    </Tooltip>
                  )}
                  no={() => <div></div>}
                />
                <HasPermission
                  role={user.role}
                  accessRules={accessRules}
                  perform="companies:delete"
                  yes={() => (
                    <Tooltip title="Delete company">
                      <Fab
                        size="small"
                        aria-label="add"
                        className={classes.margin}
                        style={{ backgroundColor: grey[400] }}
                        onClick={() => this.handleDeleteCompany()}
                      >
                        <DeleteIcon style={{ color: "white" }} />
                      </Fab>
                    </Tooltip>
                  )}
                  no={() => <div></div>}
                />
              </CardActions>
            </Card>
          )}
        </AuthConsumer>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(CompanyCardComponent);
